import { invnumberConstants } from "../constants";
import { portalFunctionalityConstants } from '../constants';

import { alertActions } from 'actions';
import { global } from 'config';
import { invnumberService } from 'services';
import { gisRoutes } from '../routes/routes';
import { history } from 'helpers';

export const invnumberActions = {
  getAll,
  get,
  getCities,
  getJurisdictions,
  add,
  addBulk,
  downloadTemplate
}

function downloadTemplate() {
  return dispatch => {

    invnumberService.downloadTemplate()
      .catch(error => {
        // dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

}

function get(invnumber_id) {
  return dispatch => {
    dispatch(request());

    invnumberService.get(invnumber_id)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: invnumberConstants.GET_INV_NUMBER_REQUEST } }
  function success(data) { return { type: invnumberConstants.GET_INV_NUMBER_SUCCESS, data } }
  function failure(error) { return { type: invnumberConstants.GET_INV_NUMBER_FAILURE, error } }
}

function getAll(limit = global.LIMIT, page = global.PAGE, filters = undefined,) {
  return dispatch => {
    dispatch(request());

    invnumberService.getAll(limit, page, filters)
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: invnumberConstants.GET_INV_NUMBERS_REQUEST } }
  function success(data) { return { type: invnumberConstants.GET_INV_NUMBERS_SUCCESS, data } }
  function failure(error) { return { type: invnumberConstants.GET_INV_NUMBERS_FAILURE, error } }
}

function getJurisdictions() {
  return dispatch => {
    dispatch(request());

    invnumberService.getJurisdictions()
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_REQUEST } }
  function success(data) {
    return { type: invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_SUCCESS, data }
  }
  function failure(error) { return { type: invnumberConstants.GET_INV_NUMBER_JURISDICTIONS_FAILURE, error } }
}

function getCities() {
  return dispatch => {
    dispatch(request());

    invnumberService.getCities()
      .then(
        data => dispatch(success(data)))
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });
  };

  function request() { return { type: invnumberConstants.GET_INV_NUMBER_CITIES_REQUEST } }
  function success(data) {
    return { type: invnumberConstants.GET_INV_NUMBER_CITIES_SUCCESS, data }
  }
  function failure(error) { return { type: invnumberConstants.GET_INV_NUMBER_CITIES_FAILURE, error } }
}

function add(newValues) {
  return dispatch => {
    dispatch(request(newValues));

    invnumberService.add(newValues)
      .then(
        data => {
          dispatch(success(data))
          dispatch(alertActions.success(data.message));
          history.push(gisRoutes.management.service_number_type.list);
        })
      .catch(error => {
        dispatch(failure(error));
        dispatch(alertActions.error(error.data || error.message));
      });

  };

  function request() { return { type: invnumberConstants.ADD_INV_NUMBER_REQUEST } }
  function success(data) { return { type: invnumberConstants.ADD_INV_NUMBER_SUCCESS, data } }
  function failure(error) { return { type: invnumberConstants.ADD_INV_NUMBER_FAILURE, error } }
}

function addBulk(file, filetypes) {
  const data = new FormData();
  const allowedtypes = [];
  filetypes.forEach(filetype => allowedtypes.push(portalFunctionalityConstants.documents[filetype]));
  if (allowedtypes.includes(file.type) && file !== null) {
    data.append('file', file);
    return dispatch => {
      dispatch(request());
      invnumberService.addBulk(data)
        .then(
          data => dispatch(success(data)) && dispatch(alertActions.success(data.message)),
          error => dispatch(failure(error.data)) && dispatch(alertActions.error(error.message))
        );
    };
  } else {
    return dispatch => {
      dispatch(alertActions.error(`Please upload ${allowedtypes.map(e => e).join("/")} file`))
    }
  }

  function request() { return { type: invnumberConstants.ADD_BULK_INV_NUMBER_REQUEST } }
  function success(data) { return { type: invnumberConstants.ADD_BULK_INV_NUMBER_SUCCESS, data } }
  function failure(error) { return { type: invnumberConstants.ADD_BULK_INV_NUMBER_FAILURE, error } }
}
